import { useEffect, useState } from "react"

const useAdmin = user => {

    const [admin, setAdmin] = useState(false);
    const [adminLoader, setAdminLoader] = useState(true);
    useEffect(() => {
        const email = user?.email;
        if (email) {
            fetch(`https://morning-thicket-25612.herokuapp.com/admin/${email}`, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',

                },

            })
                .then(res => res.json())
                .then(data => {
                    console.log('data inside admin', data);
                    setAdmin(data.admin)
                    setAdminLoader(false)
                })
        }
    }, [user])
    return [admin, adminLoader]
}

export default useAdmin;